import Raven from 'raven-js';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import Root from './containers/root';
import store from './store/configureStore';

Raven.config(process.env.REACT_APP_SENTRY_DSN).install();

// captures "Uncaught Promise Exceptions"
window.onunhandledrejection = e => {
  console.warn('Unhandled Promise Rejection', e.reason);
  Raven.captureMessage(e.reason, {
    extra: { unhandledPromise: true }
  });
};

render(
  <Provider store={store}>
    <Root />
  </Provider>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js